"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyParts = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const isBodyPartSelected_1 = require("../../utils/isBodyPartSelected");
const BodyParts = ({ className, clipPathId, disabled, image, paths, selectedBodyParts = [], onBodyPartClick, }) => {
    const onBodyPartKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onBodyPartClick(e);
        }
    };
    return (react_1.default.createElement("g", { className: className, clipPath: `url(#${clipPathId})` },
        image,
        Object.entries(paths).map(([id, pathAttributes]) => {
            const selected = (0, isBodyPartSelected_1.isBodyPartSelected)(selectedBodyParts, id);
            return (react_1.default.createElement("path", Object.assign({ key: id, id: id, "data-testid": id, role: "checkbox", "aria-checked": selected, onClick: onBodyPartClick, onKeyDown: onBodyPartKeyDown, className: (0, classnames_1.default)({ selected }), tabIndex: disabled ? undefined : 1 }, pathAttributes)));
        })));
};
exports.BodyParts = BodyParts;
//# sourceMappingURL=BodyParts.js.map